import api from '../api.js';
import { notify } from '../../versa/msgbox.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#delivery-location #company_id	{ width: 10rem; }
			#delivery-location #id			{ width: 5rem; text-align: right; }
			#delivery-location #name		{ width: 25rem; }
		</style>
		<form id="delivery-location" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa deste local">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do local">Local
					<input id="id" type="text" disabled>
				</label>
				<label title="Texto que sai no pedido, na etiqueta, no picking e no romaneio">Nome<sup>*</sup>
					<input id="name" type="text" maxlength="120" required>
				</label>
				<label title="Inativo não aparece na lista do pedido">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_delivery_location_disable" title="Inativar local">Inativar</button>
					<button type="button" class="button bn_delivery_location_enable" title="Ativar local">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form:
	{
		selector: '#delivery-location',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const root = () => formset.dialog?.getNode?.();
			const getCompanyId = () => formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
			const getId = () => root()?.querySelector?.('#id')?.value;
			const setDisabled = (value) => {
				const field = formset.form.getFieldBySelector('#is_disabled');
				if (field) {
					field.setValue(value ? 1 : 0);
					field.refresh();
				}
			};
			const doAction = async (payload) => {
				const companyId = getCompanyId();
				const id = getId();
				if (!companyId || !id)
					return;
				const resp = await api.call(api.patch_delivery_location, companyId, id, payload);
				if (resp != null)
					setDisabled(payload.is_disabled);
				else
					notify('Falha ao atualizar o local de entrega.', 'Locais de entrega');
			};
			root()?.addEventListener?.('click', (ev) => {
				if (ev.target?.closest?.('.bn_delivery_location_disable')) {
					ev.preventDefault();
					ev.stopPropagation();
					doAction({ is_disabled: true });
					return;
				}
				if (ev.target?.closest?.('.bn_delivery_location_enable')) {
					ev.preventDefault();
					ev.stopPropagation();
					doAction({ is_disabled: false });
				}
			});
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]

};
